import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Shield, MapPin, Download, Eye, FileText, Heart, XCircle,
  ChevronDown, ChevronUp, Lock, Globe, AlertTriangle, CheckCircle,
  Scale, Zap, Database, UserCheck, Ban, Brain, Sparkles
} from 'lucide-react';

import API from '../utils/api';

var STATES_WITH_LAWS = {
  AL: { name: 'Alabama', enhanced: false, rights: ['right to access', 'right to delete'] },
  AK: { name: 'Alaska', enhanced: false, rights: ['right to access', 'right to delete'] },
  AZ: { name: 'Arizona', enhanced: false, rights: ['right to access', 'right to delete'] },
  AR: { name: 'Arkansas', enhanced: false, rights: ['right to access', 'right to delete'] },
  CA: { name: 'California', enhanced: true, rights: ['right to know/access', 'right to delete', 'right to correct', 'right to opt out of sale/sharing', 'right to limit use of sensitive info', 'right not to be discriminated against'] },
  CO: { name: 'Colorado', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of targeted advertising', 'right to data portability'] },
  CT: { name: 'Connecticut', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads', 'right to data portability'] },
  DE: { name: 'Delaware', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads', 'right to data portability'] },
  FL: { name: 'Florida', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  GA: { name: 'Georgia', enhanced: false, rights: ['right to access', 'right to delete'] },
  HI: { name: 'Hawaii', enhanced: false, rights: ['right to access', 'right to delete'] },
  ID: { name: 'Idaho', enhanced: false, rights: ['right to access', 'right to delete'] },
  IL: { name: 'Illinois', enhanced: false, rights: ['right to access', 'right to delete', 'biometric data protections (BIPA)'] },
  IN: { name: 'Indiana', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of targeted ads'] },
  IA: { name: 'Iowa', enhanced: true, rights: ['right to access', 'right to delete', 'right to opt out of sale/targeted ads'] },
  KS: { name: 'Kansas', enhanced: false, rights: ['right to access', 'right to delete'] },
  KY: { name: 'Kentucky', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  LA: { name: 'Louisiana', enhanced: false, rights: ['right to access', 'right to delete'] },
  ME: { name: 'Maine', enhanced: false, rights: ['right to access', 'right to delete'] },
  MD: { name: 'Maryland', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  MA: { name: 'Massachusetts', enhanced: false, rights: ['right to access', 'right to delete', 'data breach notification'] },
  MI: { name: 'Michigan', enhanced: false, rights: ['right to access', 'right to delete'] },
  MN: { name: 'Minnesota', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads', 'right to data portability'] },
  MS: { name: 'Mississippi', enhanced: false, rights: ['right to access', 'right to delete'] },
  MO: { name: 'Missouri', enhanced: false, rights: ['right to access', 'right to delete'] },
  MT: { name: 'Montana', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  NE: { name: 'Nebraska', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  NV: { name: 'Nevada', enhanced: false, rights: ['right to access', 'right to delete', 'right to opt out of sale'] },
  NH: { name: 'New Hampshire', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  NJ: { name: 'New Jersey', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  NM: { name: 'New Mexico', enhanced: false, rights: ['right to access', 'right to delete'] },
  NY: { name: 'New York', enhanced: false, rights: ['right to access', 'right to delete', 'data breach notification'] },
  NC: { name: 'North Carolina', enhanced: false, rights: ['right to access', 'right to delete'] },
  ND: { name: 'North Dakota', enhanced: false, rights: ['right to access', 'right to delete'] },
  OH: { name: 'Ohio', enhanced: false, rights: ['right to access', 'right to delete'] },
  OK: { name: 'Oklahoma', enhanced: false, rights: ['right to access', 'right to delete'] },
  OR: { name: 'Oregon', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  PA: { name: 'Pennsylvania', enhanced: false, rights: ['right to access', 'right to delete'] },
  RI: { name: 'Rhode Island', enhanced: false, rights: ['right to access', 'right to delete'] },
  SC: { name: 'South Carolina', enhanced: false, rights: ['right to access', 'right to delete'] },
  SD: { name: 'South Dakota', enhanced: false, rights: ['right to access', 'right to delete'] },
  TN: { name: 'Tennessee', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  TX: { name: 'Texas', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  UT: { name: 'Utah', enhanced: true, rights: ['right to access', 'right to delete', 'right to opt out of sale/targeted ads'] },
  VT: { name: 'Vermont', enhanced: false, rights: ['right to access', 'right to delete', 'data broker registration'] },
  VA: { name: 'Virginia', enhanced: true, rights: ['right to access', 'right to delete', 'right to correct', 'right to opt out of sale/targeted ads'] },
  WA: { name: 'Washington', enhanced: false, rights: ['right to access', 'right to delete', 'health data protections'] },
  WV: { name: 'West Virginia', enhanced: false, rights: ['right to access', 'right to delete'] },
  WI: { name: 'Wisconsin', enhanced: false, rights: ['right to access', 'right to delete'] },
  WY: { name: 'Wyoming', enhanced: false, rights: ['right to access', 'right to delete'] },
  DC: { name: 'District of Columbia', enhanced: false, rights: ['right to access', 'right to delete'] },
};

var TABS = [
  { id: 'rights', label: 'Privacy Rights', icon: MapPin },
  { id: 'policy', label: 'Privacy Policy', icon: FileText },
  { id: 'terms', label: 'Terms of Service', icon: Scale },
  { id: 'trust', label: 'Trust & Safety', icon: Shield },
];

function Acc(props) {
  return (
    <div className="border border-white/[0.06] rounded-xl overflow-hidden">
      <button onClick={props.onToggle} className="w-full flex items-center justify-between p-4 hover:bg-white/[0.02] transition-colors">
        <div className="flex items-center gap-3">
          {props.icon && <props.icon className="w-4 h-4 text-[#5A4E9E]" />}
          <span className="text-sm font-medium text-white/70">{props.title}</span>
        </div>
        {props.open ? <ChevronUp className="w-4 h-4 text-white/30" /> : <ChevronDown className="w-4 h-4 text-white/30" />}
      </button>
      {props.open && <div className="px-4 pb-4 pt-1 border-t border-white/[0.04] text-xs text-white/50 leading-relaxed space-y-2">{props.children}</div>}
    </div>
  );
}

/* ============ PRIVACY RIGHTS TAB ============ */
function RightsTab() {
  var [selectedState, setSelectedState] = useState('');
  var stateInfo = selectedState ? STATES_WITH_LAWS[selectedState] : null;

  return (
    <div className="space-y-5">
      <div>
        <p className="text-xs text-white/40 mb-3">All Parentum users have the right to:</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {['Access your data', 'Download your data', 'Request deletion', 'Correct inaccurate data'].map(function (r) {
            return (
              <div key={r} className="flex items-center gap-2 p-2.5 bg-white/[0.02] rounded-lg">
                <CheckCircle className="w-3.5 h-3.5 text-[#10B981]" />
                <span className="text-xs text-white/60">{r}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div>
        <label className="block text-xs text-white/40 mb-2">Select your state for specific rights information:</label>
        <select value={selectedState} onChange={function (e) { setSelectedState(e.target.value); }}
          className="bg-white/[0.04] border border-white/[0.08] text-white text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:border-[#5A4E9E]/40 w-full max-w-xs"
          data-testid="state-selector">
          <option value="">-- Select State --</option>
          {Object.entries(STATES_WITH_LAWS).map(function (entry) {
            return <option key={entry[0]} value={entry[0]}>{entry[1].name}</option>;
          })}
        </select>
      </div>

      {stateInfo && (
        <div className={'p-4 rounded-xl border ' + (stateInfo.enhanced ? 'bg-[#5A4E9E]/10 border-[#5A4E9E]/20' : 'bg-white/[0.02] border-white/[0.06]')} data-testid="state-rights">
          <p className="text-sm font-medium mb-2" style={{ color: stateInfo.enhanced ? '#5A4E9E' : undefined }}>
            {stateInfo.name} Privacy Rights {stateInfo.enhanced && '(Enhanced)'}
          </p>
          <div className="space-y-1.5">
            {stateInfo.rights.map(function (r) {
              return (
                <div key={r} className="flex items-center gap-2">
                  <CheckCircle className="w-3 h-3 text-[#10B981]" />
                  <span className="text-xs text-white/50 capitalize">{r}</span>
                </div>
              );
            })}
          </div>
          {stateInfo.enhanced && (
            <p className="text-xs text-[#5A4E9E]/60 mt-3">This state has enacted comprehensive consumer privacy legislation with enhanced rights. These rights and disclosures are subject to legal review.</p>
          )}
          {!stateInfo.enhanced && (
            <p className="text-xs text-white/25 mt-3">This state provides baseline privacy protections. We provide all users with access, download, deletion, and correction rights regardless of state.</p>
          )}
        </div>
      )}

      <div className="card-surface p-5 space-y-3">
        <h4 className="text-sm font-semibold text-white/70 flex items-center gap-2"><Globe className="w-4 h-4" /> Exercise Your Rights</h4>
        <p className="text-xs text-white/40">Use the tools in your Profile page to:</p>
        <div className="space-y-2">
          <div className="flex items-center gap-3 p-3 bg-white/[0.02] border border-white/[0.06] rounded-lg">
            <Download className="w-4 h-4 text-[#5A4E9E]" />
            <span className="text-sm text-white/60">Download My Data</span>
          </div>
          <div className="flex items-center gap-3 p-3 bg-white/[0.02] border border-white/[0.06] rounded-lg">
            <XCircle className="w-4 h-4 text-[#EF4444]" />
            <span className="text-sm text-white/60">Delete My Account & Data</span>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ============ PRIVACY POLICY TAB ============ */
function PolicyTab() {
  var [o, setO] = useState({});
  function t(k) { setO(function (p) { var n = Object.assign({}, p); n[k] = !p[k]; return n; }); }

  return (
    <div className="space-y-3">
      {/* No Sale Banner */}
      <div className="p-4 bg-[#10B981]/10 border border-[#10B981]/25 rounded-xl" data-testid="no-sale-banner">
        <div className="flex items-center gap-3 mb-2">
          <Ban className="w-5 h-5 text-[#10B981]" />
          <p className="text-sm font-bold text-[#10B981]">Parentum does not sell your personal information.</p>
        </div>
        <p className="text-xs text-white/50">We do not sell, rent, or trade your data to data brokers, advertisers, or any third party for monetization purposes. This applies to all users in all states, including under the California Consumer Privacy Act (CCPA/CPRA).</p>
      </div>

      <Acc title="1. Overview" icon={Shield} open={o.overview} onToggle={function () { t('overview'); }}>
        <p>Parentum is a privacy-first AI-assisted co-parenting platform designed to help families organize parenting plans, track communication quality, and gain structured insights. We built Parentum with data minimization at its core.</p>
        <p className="text-white/70 font-medium">Parentum does not sell your personal information.</p>
        <p>We process only what is necessary and retain only sanitized structured outputs. Raw input text is temporary and deleted after processing.</p>
      </Acc>

      <Acc title="2. Information We Collect" icon={Database} open={o.collect} onToggle={function () { t('collect'); }}>
        <p><strong className="text-white/70">Account data:</strong> Email address, name, hashed password, login activity.</p>
        <p><strong className="text-white/70">User-provided text:</strong> Parenting plan text pasted into the analysis tool (temporary processing only).</p>
        <p><strong className="text-white/70">AI-generated outputs:</strong> Sanitized plan summaries, ambiguity flags, missing clause flags, structured plan data, scores.</p>
        <p><strong className="text-white/70">Application data:</strong> Journal entries, calendar events, communication checks, companion interactions, compliance scores.</p>
        <p><strong className="text-white/70">System data:</strong> Usage logs, session data, device and browser identifiers for security.</p>
      </Acc>

      <Acc title="3. What We Do NOT Collect" icon={Ban} open={o.notCollect} onToggle={function () { t('notCollect'); }}>
        <p>Parentum actively prevents the collection and storage of:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Protected health information (PHI) as defined under HIPAA</li>
          <li>Medical diagnoses, treatment details, or medication information</li>
          <li>Social Security numbers</li>
          <li>Bank accounts, routing numbers, or financial account identifiers</li>
          <li>Government-issued ID numbers (driver's license, passport)</li>
          <li>Sealed, confidential, or shielded court records</li>
          <li>Legally restricted or protected text under applicable law</li>
        </ul>
        <p className="mt-2">Our system actively detects, flags, and sanitizes this content before AI processing. Users are also warned and required to acknowledge removal of sensitive content before analysis.</p>
      </Acc>

      <Acc title="4. How Data Is Used" icon={Zap} open={o.used} onToggle={function () { t('used'); }}>
        <p>We use your data to:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Provide platform functionality (plan analysis, scoring, journaling, calendar)</li>
          <li>Generate AI-powered summaries and structured insights</li>
          <li>Support the co-parenting scoring and compliance system</li>
          <li>Maintain security, prevent fraud, and enforce terms of service</li>
          <li>Improve system performance and reliability</li>
        </ul>
        <p className="mt-2">We do <strong className="text-white/70">not</strong> use your data for advertising, behavioral profiling, or third-party monetization.</p>
      </Acc>

      <Acc title="5. AI Processing & Data Minimization" icon={Brain} open={o.ai} onToggle={function () { t('ai'); }}>
        <p>Our AI architecture follows strict data minimization principles:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li><strong className="text-white/70">Raw text is temporary:</strong> Pasted parenting plan text is held only during the active processing session.</li>
          <li><strong className="text-white/70">Pre-processing scan:</strong> All input is automatically scanned for sensitive content (medical terms, SSNs, financial data, sealed content).</li>
          <li><strong className="text-white/70">Sanitization:</strong> Detected sensitive content is replaced with neutral placeholders (e.g., [HEALTH_CONCERN], [REDACTED_ID]).</li>
          <li><strong className="text-white/70">No reverse mapping:</strong> We do not maintain a lookup table to recover original sensitive data from placeholders.</li>
          <li><strong className="text-white/70">Structured output only:</strong> AI transforms sanitized input into structured fields. Only these outputs are retained.</li>
          <li><strong className="text-white/70">Per-account isolation:</strong> Each family's data is fully isolated. No data is commingled between accounts.</li>
        </ul>
        <p className="mt-2">Parentum is not a document storage platform. It is a processing and insight tool.</p>
      </Acc>

      <Acc title="6. Data Retention Policy" icon={Database} open={o.retention} onToggle={function () { t('retention'); }}>
        <p><strong className="text-white/70">Raw pasted text:</strong> Temporary processing only. Deleted after user review is complete or session ends.</p>
        <p><strong className="text-white/70">Sanitized structured outputs:</strong> Retained for ongoing platform functionality, scoring, and user access.</p>
        <p><strong className="text-white/70">System logs:</strong> Retained per operational and security policy.</p>
        <p className="mt-2"><strong className="text-white/70">Retention exceptions:</strong> Some data may be retained longer when required for:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Legal compliance and regulatory obligations</li>
          <li>Fraud and security prevention</li>
          <li>Billing and subscription records</li>
          <li>Dispute resolution</li>
          <li>Valid legal holds or subpoenas</li>
        </ul>
      </Acc>

      <Acc title="7. No Sale of Data" icon={Ban} open={o.nosale} onToggle={function () { t('nosale'); }}>
        <div className="p-3 bg-[#10B981]/10 border border-[#10B981]/20 rounded-lg mb-2">
          <p className="text-white/70 font-semibold text-sm">Parentum does not sell, rent, or trade your personal information.</p>
        </div>
        <p>This means:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>No data broker relationships</li>
          <li>No advertising-driven data sharing</li>
          <li>No third-party monetization of user data</li>
          <li>No cross-context behavioral advertising</li>
        </ul>
        <p className="mt-2"><strong className="text-white/70">California Residents:</strong> Under the California Consumer Privacy Act (CCPA/CPRA), we confirm that we do not "sell" or "share" your personal information as defined by California law. We do not engage in cross-context behavioral advertising using your data.</p>
      </Acc>

      <Acc title="8. Third-Party Providers" icon={Globe} open={o.thirdparty} onToggle={function () { t('thirdparty'); }}>
        <p>Parentum works with trusted infrastructure and service providers to deliver our platform:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li><strong className="text-white/70">Cloud hosting:</strong> Secure cloud infrastructure for application delivery</li>
          <li><strong className="text-white/70">AI processing:</strong> Language model providers for text analysis (input is sanitized before transmission)</li>
          <li><strong className="text-white/70">Payment processing:</strong> Secure payment provider for subscription billing</li>
        </ul>
        <p className="mt-2">All third-party providers are contractually restricted from using your data independently. They may only process data on our behalf and in accordance with our privacy commitments.</p>
      </Acc>

      <Acc title="9. Third-Party Integrations & Connected Services" icon={Globe} open={o.connected_services} onToggle={function () { t('connected_services'); }}>
        <p>Users who choose to connect third-party services, including Google Calendar, to their Parentum account acknowledge and understand that information imported, synced, stored, transmitted, or generated through those integrations may become part of their Parentum account activity and records. While Parentum takes reasonable measures to protect user data, users should understand that account-related information, including synced calendar information, messages, journals, scheduling data, and other platform activity, may be subject to disclosure, preservation, or production in response to valid subpoenas, court orders, legal process, or other lawful governmental requests. Users are solely responsible for determining what information they choose to connect, upload, sync, store, or transmit through the platform and should avoid linking or sharing information they would not want potentially disclosed through lawful legal proceedings.</p>
      </Acc>

      <Acc title="10. Privacy Rights" icon={UserCheck} open={o.rights} onToggle={function () { t('rights'); }}>
        <p>All users have the right to access, download, correct, and delete their personal data. See the <strong className="text-white/70">Privacy Rights</strong> tab for state-specific rights, including California-enhanced rights under CCPA/CPRA.</p>
      </Acc>

      <Acc title="11. Data Download & Deletion" icon={Download} open={o.download} onToggle={function () { t('download'); }}>
        <p><strong className="text-white/70">Download:</strong> Available in Profile &gt; Account & Privacy. Includes account info, structured plan data, summaries, scoring data, and version history. Excludes raw text, internal system logic, and other users' data.</p>
        <p><strong className="text-white/70">Deletion:</strong> Available in Profile &gt; Account & Privacy. Deletes all user data including structured outputs, companion data, journal entries, and calendar data. Billing records may be retained as legally required.</p>
      </Acc>

      <Acc title="12. Security" icon={Lock} open={o.security} onToggle={function () { t('security'); }}>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>All data encrypted in transit (TLS) and at rest</li>
          <li>Passwords hashed with industry-standard algorithms</li>
          <li>Role-based access controls and least-privilege architecture</li>
          <li>Audit logging for access and data operations</li>
          <li>Sensitive content redacted from logs and error reports</li>
          <li>Session expiration and secure token management</li>
          <li>Data minimization enforced at the architecture level</li>
        </ul>
      </Acc>

      <Acc title="13. Legal Requests & Subpoenas" icon={AlertTriangle} open={o.legal} onToggle={function () { t('legal'); }}>
        <p>Parentum may preserve or disclose data when required by valid legal process, including subpoenas, court orders, or government requests.</p>
        <p className="mt-1">We maintain:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Auditable records of stored sanitized data</li>
          <li>Legal-hold flags to pause deletion when legally required</li>
          <li>Access and disclosure event logging</li>
        </ul>
        <p className="mt-2">Where permitted by law, we will notify users of legal requests affecting their data. We only preserve data that was retained under our policy -- raw data already deleted is not recoverable.</p>
      </Acc>

      <p className="text-xs text-white/20 text-center pt-2">Privacy policy content is subject to legal review before production release. Last framework update: 2026.</p>
    </div>
  );
}

/* ============ TERMS OF SERVICE TAB ============ */
function TermsTab() {
  var [sections, setSections] = useState([]);
  var [version, setVersion] = useState('');
  var [loading, setLoading] = useState(true);
  var [expanded, setExpanded] = useState({});

  useEffect(function () {
    axios.get(API + '/tos/current')
      .then(function (r) {
        setSections(r.data.sections || []);
        setVersion(r.data.version || '');
        setLoading(false);
      })
      .catch(function () { setLoading(false); });
  }, []);

  function toggle(id) { setExpanded(function (p) { var n = Object.assign({}, p); n[id] = !p[id]; return n; }); }

  if (loading) return <div className="py-8 text-center text-white/40 text-sm">Loading Terms of Service...</div>;

  return (
    <div className="space-y-3">
      <div className="p-4 bg-white/[0.02] border border-white/[0.06] rounded-xl flex items-center justify-between">
        <p className="text-xs text-white/50">By using Parentum, you agree to these Terms of Service. Please read them carefully.</p>
        {version && <span className="text-xs text-white/20 flex-shrink-0 ml-2">v{version}</span>}
      </div>

      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#10B981]/10 border border-[#10B981]/20" data-testid="data-non-sale-badge-privacy">
        <Shield className="w-3.5 h-3.5 text-[#10B981]" />
        <span className="text-xs text-[#10B981] font-medium">Parentum does not sell, rent, or trade your personal data.</span>
      </div>

      {sections.map(function (s) {
        var icon = s.highlight ? AlertTriangle : Scale;
        return (
          <Acc key={s.id} title={s.title} icon={icon} open={expanded[s.id]} onToggle={function () { toggle(s.id); }}>
            {s.highlight && (
              <div className="p-3 bg-[#F59E0B]/10 border border-[#F59E0B]/20 rounded-lg mb-2">
                <p className="text-xs text-[#F59E0B] font-semibold">Critical Legal Disclaimer</p>
              </div>
            )}
            <p className="whitespace-pre-line">{s.content}</p>
          </Acc>
        );
      })}

      <p className="text-xs text-white/20 text-center pt-2">Terms of Service version {version}. Last updated: 04/12/2026. Contact: Support@parentum.app</p>
    </div>
  );
}

/* ============ TRUST & SAFETY TAB ============ */
function TrustTab() {
  var cards = [
    {
      icon: Lock, color: '#5A4E9E', title: 'Privacy-First Design',
      body: 'Parentum is built on a privacy-first architecture. We collect only what is necessary, process it securely, and retain only sanitized structured outputs. Raw input is temporary and never stored long-term.'
    },
    {
      icon: Ban, color: '#10B981', title: 'Your Data Is Never Sold',
      body: 'Parentum does not sell, rent, or trade your personal information. We have no data broker relationships, no advertising data sharing, and no third-party monetization of user data. Your data serves one purpose: helping your family.'
    },
    {
      icon: Brain, color: '#5A4E9E', title: 'Safe AI Processing',
      body: 'Our AI creates summaries and structured insights -- never legal conclusions. Input is scanned and sanitized before processing. Sensitive content is replaced with neutral placeholders. The AI never retains or outputs medical diagnoses, financial identifiers, or protected information.'
    },
    {
      icon: Database, color: '#EAB308', title: 'Minimal Data, Maximum Security',
      body: 'We do not store documents. Parenting plans are paste-only, processed temporarily, and deleted after review. Only the structured analysis output is retained. Encryption protects data in transit and at rest. Passwords are securely hashed.'
    },
    {
      icon: UserCheck, color: '#3B82F6', title: 'You Are In Control',
      body: 'Download your data anytime. Delete your account and all data permanently. Cancel your subscription without losing data. Manage companion settings, safety modes, and privacy preferences. Your data lifecycle is in your hands.'
    },
    {
      icon: Shield, color: '#EC4899', title: 'Auditable & Defensible',
      body: 'We maintain audit logs for data access and operations. Legal holds can pause deletion when legally required. Our retention policies are documented and enforceable. The system is designed to withstand legal scrutiny.'
    },
  ];

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {cards.map(function (c) {
          var Icon = c.icon;
          return (
            <div key={c.title} className="p-5 bg-white/[0.02] border border-white/[0.06] rounded-xl space-y-3" data-testid={'trust-' + c.title.toLowerCase().replace(/\s/g, '-')}>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ backgroundColor: c.color + '15' }}>
                  <Icon className="w-4.5 h-4.5" style={{ color: c.color }} />
                </div>
                <h4 className="text-sm font-semibold text-white/80">{c.title}</h4>
              </div>
              <p className="text-xs text-white/45 leading-relaxed">{c.body}</p>
            </div>
          );
        })}
      </div>

      <div className="p-6 bg-gradient-to-br from-[#5A4E9E]/10 to-[#2D2560]/10 border border-[#5A4E9E]/20 rounded-xl text-center" data-testid="trust-closing">
        <Heart className="w-6 h-6 text-[#2D2560] mx-auto mb-3" />
        <p className="text-sm font-semibold text-white/80 mb-1">Your data is not our business model.</p>
        <p className="text-sm text-white/80">Helping families is.</p>
      </div>
    </div>
  );
}

/* ============ MAIN COMPONENT ============ */
function PrivacyCenter() {
  var [activeTab, setActiveTab] = useState('rights');

  return (
    <div className="space-y-6" data-testid="privacy-center-page">
      <div className="card-surface p-6">
        <div className="flex items-center gap-3 mb-1">
          <Shield className="w-5 h-5 text-[#5A4E9E]" />
          <h2 className="text-2xl font-bold">Privacy & Legal Center</h2>
        </div>
        <p className="text-white/50 text-sm">Privacy policy, terms of service, your rights, and our trust commitments</p>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 p-1 bg-white/[0.03] border border-white/[0.06] rounded-xl">
        {TABS.map(function (tab) {
          var Icon = tab.icon;
          var active = activeTab === tab.id;
          return (
            <button key={tab.id} onClick={function () { setActiveTab(tab.id); }}
              className={'flex-1 flex items-center justify-center gap-2 py-2.5 rounded-lg text-xs font-medium transition-all ' +
                (active ? 'bg-[#5A4E9E]/15 text-[#5A4E9E] border border-[#5A4E9E]/25' : 'text-white/40 hover:text-white/60 border border-transparent')}
              data-testid={'tab-' + tab.id}>
              <Icon className="w-3.5 h-3.5" />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className="card-surface p-6">
        {activeTab === 'rights' && <RightsTab />}
        {activeTab === 'policy' && <PolicyTab />}
        {activeTab === 'terms' && <TermsTab />}
        {activeTab === 'trust' && <TrustTab />}
      </div>

      <div className="p-3 bg-white/[0.02] rounded-lg">
        <p className="text-xs text-white/20 text-center">
          Parentum provides AI-assisted summaries and insights for educational and organizational purposes. Always refer to your official court order as the controlling document.
        </p>
      </div>
    </div>
  );
}

export default PrivacyCenter;
